export const GUEST_MAX_CHAPTERS_ALLOWED = 10;
export const GUEST_CHAPTERS_READ_STORAGE_KEY = 'anon-chapters-read';
